const NS = 'HighChartsService';

export default function HighChartsService(
  $timeout
) {
  "ngInject";

  return {
    graphConfig: function (obj) {
      return {
        options: {
          chart: {
            type: obj.type
          },
          colors: ['#dadada', '#A91164'],
          plotOptions: {
            series: {
              stacking: ''
            },
            column: {
              borderColor: '#A91164',
              cropThreshold: 10
            },
            spline: {
              marker: {
                radius: 0,
              }
            }
          },
          func: function (chart) {
            // $scope.highchartRef = chart; // removed as $scope is undefined in a service and 'highchartRef' not used anywhere
            $timeout(function () {
              chart.reflow();
            }, 100);
          }
        },
        xAxis: {
          categories: obj.xAxis
        },
        yAxis: {
          title: {
            text: obj.yAxisTitle
          },
          allowDecimals: true,
          maxPadding: 0
        },
        series: obj.series,
        title: {
          text: obj.graphTitle
        },
        credits: {
          enabled: false
        },
        loading: false,
        size: {},
      };
    },
  };
};
